"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FakeVideoAIMetadataClient {
    clear() { }
    getLearningOutcomes(videoId) {
        return Promise.resolve({ learningOutcomes: [`outcome for ${videoId}`] });
    }
    getAssessmentQuestions(videoId) {
        return Promise.resolve({
            assessmentQuestions: [`questions for ${videoId}`],
        });
    }
}
exports.default = FakeVideoAIMetadataClient;
//# sourceMappingURL=FakeVideoAIMetadataClient.js.map